module.exports = __webpack_public_path__ + "media/images/card-details-indicator-ea7b597e338523379c31967fab9c81f3.svg";